import {RentalDocumentType, ReturnalDocumentType} from "../api/dtos/dtos";
import locales from "../locales";

export const documentTypeToText = {
  [RentalDocumentType.RENTAL_CONTRACT]: locales.document_type_rental_contract,
  [RentalDocumentType.TERMS_AND_CONDITIONS]: locales.document_type_terms,
  [RentalDocumentType.MAINTENANCE_GUIDE]: locales.document_type_maintenance,
  [RentalDocumentType.TRANSPORT_LETTER]: locales.document_type_transport_letter,
  [RentalDocumentType.DEPOSIT_REQUEST]: locales.document_type_deposit_request,
  [ReturnalDocumentType.RETURNAL_REPORT]: locales.document_type_returnal_contract,
  [ReturnalDocumentType.TRANSPORT_LETTER]: locales.document_type_transport_letter,
};


// WEBPACK FOOTER //
// ./src/document-sendout/dtos.ts